<i18n>
{
  "en": {
    "filesystem": {
      "show": "Show",
      "download": "Download",
      "move": "Move",
      "delete": "Delete",
      "createFolder": "Create folder"
    }
  }
}
</i18n>

<template>
  <section>
    <ul
      v-show="opened"
      :class="[`level-${level}`]"
      class="filesystem__folder"
    >
      <li
        v-for="(object, key) in objects"
        :key="key"
        class="filesystem__object"
      >
        <span class="filesystem__offset" />
        <button
          v-if="object.children.length > 0"
          :class="[{ 'opened' : object.opened }]"
          type="button"
          class="filesystem__toggle"
          @click="toggle(key)"
        >
          <span v-if="object.opened">
            <font-awesome-icon
              icon="minus"
              size="xs"
            />
          </span>
          <span v-else>
            <font-awesome-icon
              icon="plus"
              size="xs"
            />
          </span>
        </button>
        <span class="filesystem__select">
          <input
            v-model="object.selected"
            type="checkbox"
            value="1"
          >
        </span>
        <span class="filesystem__id">
          {{ object.id }}
        </span>
        <span
          v-if="object.type === 'file'"
          class="filesystem__meta"
        >
          <span class="filesystem__size">
            {{ object.item.Size }}
          </span>
          <span class="filesystem__mtime">
            {{ object.item.LastModified }}
          </span>
          <button
            type="button"
            @click="show(object)"
          >
            {{ $t('filesystem.show') }}
          </button>
          <button
            type="button"
            @click="download(object)"
          >
            {{ $t('filesystem.download') }}
          </button>
          <button
            type="button"
            @click="move(object)"
          >
            {{ $t('filesystem.move') }}
          </button>
          <button
            type="button"
            @click="remove(object)"
          >
            {{ $t('filesystem.delete') }}
          </button>
        </span>
        <span v-else>
          <button
            type="button"
            @click="createFolder()"
          >
            {{ $t('filesystem.createFolder') }}
          </button>
        </span>
        <filesystem-list
          v-if="object.children.length !== 0"
          :objects="object.children"
          :opened="object.opened"
          :level="level + 1"
          :parent-path="currentPath(object.id)"
        />
      </li>
    </ul>
  </section>
</template>

<script>
/* eslint no-console: ["off"] */
/* eslint no-alert: ["off"] */
import { mapState, mapActions } from 'vuex';

export default {
  name: 'FilesystemList',
  props: {
    objects: {
      type: Array,
      default() {
        return [];
      },
    },
    opened: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 0,
    },
    parentPath: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      path: state => state.filesystem.path,
      delimiter: state => state.filesystem.delimiter,
    }),
  },
  methods: {
    createFolder() {
      const name = prompt('Please enter folder name', '');

      if (name !== null && name !== '') {
        this.$http
          .get('/filesystem/create', {
            params: {
              name: `${name}${this.delimiter}`,
              path: `${this.parentPath}${this.delimiter}`,
            },
          })
          .then(() => {
            this.$toast.show('Folder succesully created', {
              duration: 1000,
            });
            this.$store.dispatch('filesystem/load');
          });
      }
    },
    move(object) {
      this.$http
        .get('/filesystem/move', {
          params: {
            object: object.item,
            path: `${this.parentPath}${this.delimiter}`,
          },
        })
        .then(() => {
          this.$toast.show('Object moved', {
            duration: 1000,
          });
          this.$store.dispatch('filesystem/load');
        });
    },
    show(object) {
      this.$http
        .get('/filesystem/getSignedUrl', {
          params: {
            object: object.item,
          },
        })
        .then(response => {
          window.location.href = response.data;
        });
    },
    download(object) {
      this.$http
        .get('/filesystem/getSignedUrl', {
          params: {
            object: object.item,
          },
        })
        .then(response => {
          window.location.href = response.data;
        });
    },
    remove(object) {
      this.$http
        .get('/filesystem/remove', {
          params: {
            object: object.item,
          },
        })
        .then(() => {
          this.$store.dispatch('filesystem/load');
        });
    },
    getNestedPath(id) {
      return `${this.parentPath}${
        this.parentPath !== '' ? this.delimiter : ''
      }${id}`;
    },
    toggle(key) {
      this.objects[key].opened = !this.objects[key].opened;
      if (this.objects[key].opened) {
        this.setPath(this.getNestedPath(this.objects[key].id));
      } else {
        this.setPath(`${this.parentPath}`);
      }
    },
    currentPath(id) {
      return this.getNestedPath(id);
    },
    ...mapActions({
      setPath: 'filesystem/set_path',
    }),
  },
};
</script>

<style lang="scss" scoped>
.filesystem__folder {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.filesystem__object {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

// Nesting
.filesystem__offset {
  display: inline-block;
}

.filesystem__offset + .filesystem__toggle {
  margin-left: -20px;
}

.level-0 {
  .filesystem__offset {
    margin-left: 20px;
  }
}

.level-1 {
  .filesystem__offset {
    margin-left: 40px;
  }
}

.level-2 {
  .filesystem__offset {
    margin-left: 60px;
  }
}

.filesystem__toggle {
  display: inline-block;
  width: 24px;
  height: 24px;
  appearance: none;
  border: 1px solid #ccc;
  color: 1px solid #ccc;
  outline: none;
  cursor: pointer;
  user-select: none;
}

.filesystem__meta {
  opacity: 0.4;
  font-size: 60%;
}
</style>
